<template>
    <div class="read-wrap">
        <div class="header-wrp">
            <Header></Header>
        </div>
        <img-bg
            :poster="bgUrl"
            :opacity='"1"'
            :isRelative="false"
            :height="391"></img-bg>
        <div class="read-content">
            <div class="read-wrapper">
                <div class="read-title">
                    <img src="https://image1.guazistatic.com/icon-read_title.png" width="48" height="48">
                    <div class="header-text">
                        <p class="header-text-name">{{initData.supplierName ||''}}</p>
                        <p class="header-text-id">{{initData.supplierCode ||''}}</p>
                    </div>
                </div>
                <div class="read-content-icon">
                    {{initData.registerStatusDes}}
                </div>
                <content-tank
                    ref="basicRef"
                    title="基本信息"
                    >
                    <div
                        slot="content">
                        <sdm-basic
                            ref="sdmBasicRef"
                            :read-only="this.type===0"
                            :isModify="true"
                            :contain-categorys="containCategorys"
                            @updateBasicInfo="updateBasicInfo"
                            :init-data="basicInitData"></sdm-basic>
                    </div>
                </content-tank>
                <content-tank
                    ref="bankRef"
                    v-if="initDataLoad"
                    title="银行信息">
                    <div
                        slot="content">
                        <sdm-bank
                            ref="sdmBankRef"
                            is-show-status
                            :read-only="this.type===0"
                            :sdm-name="sdmName"
                            :filter-keys="['purpose', 'businessDept']"
                            :init-data="bankInitData"></sdm-bank>
                    </div>
                </content-tank>
                <content-tank
                    ref="addressRef"
                    title="地址信息">
                    <div
                        v-if="initDataLoad"
                        slot="content">
                        <sdm-address
                            ref="sdmAddressRef"
                            is-show-status
                            :read-only="this.type===0"
                            :sdm-type="sdmType"
                            :init-data="addressInitData"></sdm-address>
                    </div>
                </content-tank>
                <content-tank
                    ref="contactsRef"
                    v-if="initDataLoad"
                    title="联系人信息">
                    <div
                        slot="content">
                        <sdm-contacts
                            ref="sdmContactsRef"
                            is-show-status
                            :read-only="this.type===0"
                            :init-data="contactsInitData"></sdm-contacts>
                    </div>
                </content-tank>
                <content-tank
                    ref="categoryRef"
                    v-if="initDataLoad"
                    title="品类信息">
                    <div
                        slot="content">
                        <sdm-category
                            ref="sdmCategoryRef"
                            is-show-status
                            :read-only="this.type===0"
                            :init-data="categoryInitData"
                            @updateCategory="updateCategory"></sdm-category>
                    </div>
                </content-tank>
                <content-tank
                    ref="othersRef"
                    title="业务附加信息">
                    <div
                        slot="content">
                        <sdm-others
                            v-if="initDataLoad&&isAddtionVisible"
                            ref="sdmOthersRef"
                            :read-only="this.type===0"
                            :contain-categorys="containCategorys"
                            @updateOthersInfo="updateOthersInfo"
                            :init-data="othersInitData"></sdm-others>
                        <!-- <div v-else>无</div> -->
                    </div>
                </content-tank>
                <content-tank
                    ref="qualificationRef"
                    v-if="initDataLoad"
                    title="资质信息">
                    <div
                        slot="content">
                        <sdm-qualification
                            ref="sdmQualificationRef"
                            is-show-status
                            :supplier-types="supplierTypes"
                            :read-only="this.type===0"
                            :sdm-type="sdmType"
                            :init-data="qualificatioInitData"></sdm-qualification>
                    </div>
                </content-tank>
                <div
                    class="txt-center">
                    <el-button
                        v-if="type!==0"
                        type="primary"
                        round
                        :loading="saveLoading"
                        @click="doSave">提交</el-button>
                    <el-button
                        :loading="saveLoading"
                        round
                        @click="doBack">返回</el-button>
                </div>
            </div>
        </div>
        <div class="nav-right">
            <ul ref="ul">
                <li
                    v-for="(item,index) in menuList"
                    :key="index"
                    @click="toCurrentEle(index)"
                    :class="{'font-light':currentIndex===index}"
                    >{{item.name}}</li>
            </ul>
            <div class="nav-light" :style="curNavStyle"></div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import throttle from 'lodash/throttle'
import { SdmService } from '@service'

export default {
    name: 'supplierHome',
    data() {
        return {
            bgUrl: 'https://image1.guazistatic.com/trans_sdm_bg.png',
            menuList: [{
                name: '基本信息',
                ref: 'basicRef',
            }, {
                name: '银行信息',
                ref: 'bankRef',
            }, {
                name: '地址信息',
                ref: 'addressRef',
            }, {
                name: '联系人信息',
                ref: 'contactsRef',
            }, {
                name: '品类信息',
                ref: 'categoryRef',
            }, {
                name: '业务附加信息',
                ref: 'sdmOthersRef',
            }, {
                name: '资质信息',
                ref: 'qualificationRef',
            }],
            iphone: '',
            currentIndex: 0,
            initDataLoad: true,
            hackReset: true,
            saveLoading: false,
            dialogTableVisible: false,
            sdmName: '',
            sdmType: 0,
            sendkeys: {
                bank: 'supplierBankReqDTOList',
                address: 'supplierAddressReqDTOList',
                contacts: 'supplierContactReqDTOList',
                category: 'supplierSuppliesCategoryReqDTOList',
                qualification: 'supplierQualificationReqDTOList',
                others: 'supplierBaseInfoExtReqDTOList',
            },
            containCategorys: [],
            initData: {},
            basicInitData: {},
            bankInitData: [],
            addressInitData: [],
            contactsInitData: [],
            categoryInitData: [],
            qualificatioInitData: [],
            othersInitData: [],
            supplierTypes: [],
            throttledCheckScroll: null,
            tankLabel: {
                basic: '基本信息',
                bank: '银行信息',
                address: '地址信息',
                contacts: '联系人信息',
                category: '品类信息',
                qualification: '资质信息',
                others: '业务附加信息',
            },
            type: 0,
        }
    },
    computed: {
        ...mapState({
            countrys: (state) => state.baseData.countrys,
            banks: (state) => state.baseData.banks,
        }),
        isAddtionVisible() {
            let { othersInitData } = this
            return othersInitData.length
        },
        curNavStyle() {
            const curTop = this.currentIndex * 44 + 14
            return {
                top: this.currentIndex ? `${curTop}px` : '14px',
            }
        },
    },
    created() {
        const { countrys, banks } = this
        if (!countrys || !countrys.length) {
            this.loadCountrys()
        }
        if (!banks || !banks.length) {
            this.loadBanks()
        }
        this.getInitData()
        this.type = this.$route.query.type == 1 ? 1 : 0
        this.throttledCheckScroll = throttle(this.checkScroll, 100)
    },
    mounted() {
        window.addEventListener('scroll', this.throttledCheckScroll, false)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.throttledCheckScroll, false)
    },
    methods: {
        ...mapActions(['loadCountrys', 'loadBanks', 'loadUserInfo']),
        updateCategory(categorys) {
            this.containCategorys = categorys || []
            if (!this.isAddtionVisible) {
                this.updateOthersInfo({
                    supplierType: [],
                })
            }
        },
        updateBasicInfo(basicInfo) {
            if (basicInfo) {
                let { supplierName, type } = basicInfo
                this.sdmName = supplierName
                this.sdmType = type
            }
        },
        async getInitData() {
            let res = await this.loadUserInfo()
            let { data } = res.data
            this.initDetail(data)
        },
        doBack() {
            this.$router.push('/nav')
        },
        updateOthersInfo(othersInfo) {
            this.supplierTypes = othersInfo.supplierType
        },
        toCurrentEle(index) {
            this.currentIndex = index
            const currentEle = this.menuList[index].ref
            this.$nextTick(() => {
                this.$refs[currentEle].$refs.sonRef.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                })
            })
        },
        initDetail(data) {
            let { R } = this
            let initData = data
            this.updateBasicInfo(data)
            if (initData.intentionProject && !Array.isArray(initData.intentionProject)) {
                initData.intentionProject = data.intentionProject.split('，')
            }
            this.initData = initData
            this.basicInitData = {
                ...R.omit(['supplierBankRespDTOList', 'supplierAddressRespDTOList', 'supplierContactRespDTOList', 'supplierSuppliesCategoryRespDTOList', 'supplierQualificationRespDTOList'], initData),
                ...{
                    invoiceType: initData.invoiceType ? initData.invoiceType.split(',').map(Number) : [],
                },
            }
            this.addressInitData = data.supplierAddressRespDTOList || []
            this.contactsInitData = data.supplierContactRespDTOList || []
            this.qualificatioInitData = data.supplierQualificationRespDTOList || []
            this.bankInitData = data.supplierBankRespDTOList || []
            let categoryInitData = data.supplierSuppliesCategoryRespDTOList || []
            let categorys = Array.from(new Set(R.filter((n) => n)(R.pluck('firstCatCode')(categoryInitData))))
            this.updateCategory(categorys)
            this.categoryInitData = categoryInitData
            let othersInitData = data.supplierBaseInfoExtRespDTOList || []
            if (othersInitData.supplierType) {
                othersInitData.supplierType = othersInitData.supplierType.split(',')
                this.updateOthersInfo(othersInitData)
            }
            this.othersInitData = othersInitData
            this.initDataLoad = true
        },
        doSave() {
            let { sendkeys, isAddtionVisible } = this
            let basic = this.$refs.sdmBasicRef.getData()
            let bank = this.$refs.sdmBankRef.getData()
            let address = this.$refs.sdmAddressRef.getData()
            let contacts = this.$refs.sdmContactsRef.getData()
            let category = this.$refs.sdmCategoryRef.getData()
            let qualification = this.$refs.sdmQualificationRef.getData()
            let promiseArr = [basic, bank, address, contacts, category, qualification]
            if (isAddtionVisible) {
                let others = this.$refs.sdmOthersRef.getData()
                promiseArr.push(others)
            }
            Promise.all(promiseArr).then((results) => {
                let work = {}
                let supplierBaseInfoReqDTO = {}
                for (let i = 0; i < results.length; i++) {
                    const { module, data } = results[i]
                    if (module === 'basic') {
                        work.id = data.id
                        work.intentionProject = data.intentionProject && data.intentionProject.join('，')
                        supplierBaseInfoReqDTO = Object.assign(supplierBaseInfoReqDTO, data)
                    } else {
                        supplierBaseInfoReqDTO = Object.assign(supplierBaseInfoReqDTO, {
                            [sendkeys[module]]: data,
                        })
                    }
                }
                work.supplierBaseInfoReqDTO = supplierBaseInfoReqDTO
                this.saveLoading = true
                work.fromSystem = this.initData.fromSystem
                SdmService.editSdm(work).then((response) => {
                    let { data: { code, message } } = response
                    if (code === 'S00000') {
                        this.$message.success('保存成功')
                        this.type = 0
                    } else {
                        this.$message.error(message)
                    }
                    this.saveLoading = false
                }).catch((err) => {
                    this.saveLoading = false
                })
            }).catch((err) => {
                let { module, message } = err
                let { tankLabel } = this
                if (!message) {
                    this.$message.warning(`${tankLabel[module]}内字段存在填写错误, 请先检查`)
                }
            })
        },
        checkScroll() {
            // let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            // if(scrollTop){

            // }

        },
    },
}
</script>

<style lang="scss">
.read-wrap{
    .header-wrp{
        height: 70px;
        z-index: 2020;
    }
    .read-content{
        position: relative;
        width:70%;
        // height:calc(100vh - 70px);
        margin:10px auto;
        padding:40px;
        background-color: #fff;
        overflow-x: auto;
        .read-wrapper{
            min-width: 1040px;
            max-width: 1200px;
            margin: 0 auto;
        }
        &-icon{
            width:90px;
            height:43px;
            position:absolute;
            right:40px;
            top:0;
            text-align: center;
            line-height: 34px;
            font-size:14px;
            color:#fff;
            background: url('https://image1.guazistatic.com/icon-zhunru.png') no-repeat 0 center;
            background-size: 90px 43px;

        }
        .read-title{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom:40px;
            .header-text{
                margin-left:10px;
                &-name{
                    font-size: 18px;
                    font-family: Microsoft YaHei;
                    font-weight: bold;
                    color: #343434;
                    line-height: 24px;
                }
                &-id{
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #9298A8;
                    line-height: 24px;
                }
            }
        }
    }
    .nav-right{
        position: fixed;
        right:60px;
        top:180px;
        padding-left:10px;
        border-left:2px solid #E4E4E4;
        li{
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #424C58;
            line-height: 44px;
            &:hover{
                color:#06B656;
                cursor: pointer;
            }
        }
        .nav-light{
            position: absolute;
            left:-8px;
            top:14px;
            width: 11px;
            height: 11px;
            background: #FFFFFF;
            border: 2px solid #27B91B;
            border-radius: 50%;
            transition: 0.5s;
        }
        .font-light{
            color:#06B656;
        }

    }

}
</style>
